import type { Medicine, MedicineProduct } from '~/models'
import { PullService } from './servicePull'
import { getDoc } from 'firebase/firestore'

export class MedicineServicePull extends PullService<Medicine, Medicine[]> {
  private doc

  constructor() {
    super()
    const { doc } = useFirebase()
    this.doc = doc
  }

  public async getMedicineByProductId(productId: string): Promise<Medicine> {
    const medicineProductSnapshot = await getDoc(
      this.doc<MedicineProduct>('MedicineProducts', productId),
    )

    if (!medicineProductSnapshot.exists()) {
      throw new Error(`MedicineProduct with ID ${productId} does not exist`)
    }

    const medicineProduct = medicineProductSnapshot.data() as MedicineProduct

    if (!medicineProduct.MedicineRef) {
      throw new Error(
        `MedicineRef not found for MedicineProduct ID ${productId}`,
      )
    }

    const medicineSnapshot = await getDoc(
      this.doc<Medicine>(medicineProduct.MedicineRef.id),
    )

    if (!medicineSnapshot.exists()) {
      throw new Error(
        `Medicine with ID ${medicineProduct.MedicineRef.id} does not exist`,
      )
    }

    return medicineSnapshot.data() as Medicine
  }
}
